import { TabBarProps } from "modules/tabbar";
import styles from "./TapBar.module.css";


export default function TabBar({ tabs, activeTab, onTabClick }: TabBarProps) {
  return (
    <div className={styles.tabMenu}>
      {tabs.map((tab, index) => (
        <button
          key={tab.id}
          className={`
            ${styles.tabButton} 
            ${index === 0 ? styles.tabButtonLeft : ""} 
            ${index === tabs.length - 1 ? styles.tabButtonRight : ""} 
            ${activeTab === tab.id ? styles.tabActive : ""}
          `}
          onClick={() => onTabClick(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
